"use strict";
/**
 * 站点级 SEO 常量（唯一事实来源）。
 *
 * 该文件同时被浏览器端（src/utils/seo.js）与构建期脚本（tools/seo/*.js）引用，
 * 因此使用 CommonJS 写法：webpack 打包时可以正常 require / import，
 * Node 侧也能直接 require，避免"两处各维护一份文案"。
 *
 * 站点域名可通过环境变量 VUE_APP_SITE_URL 覆盖（见 .env / .env.example）。
 */

var DEFAULT_SITE_URL = "https://www.workatdata.com";

/** 读取构建期注入的站点域名；浏览器端若未注入则回退默认值 */
function siteUrlFromEnv() {
  try {
    // 注意：这里保持字面量写法，构建期由 webpack.DefinePlugin 替换为字符串
    if (process.env.VUE_APP_SITE_URL) return process.env.VUE_APP_SITE_URL;
  } catch (e) {
    /* 浏览器端未注入 process 时忽略 */
  }
  return "";
}

var SITE_URL = String(siteUrlFromEnv() || DEFAULT_SITE_URL).replace(/\/+$/, "");

/**
 * 站点访问前缀（部署在子路径时使用，例如访问地址为 https://host/xxx/ 就配 /xxx）。
 * 归一化规则：空 / '/' → ''（根路径部署）；其余统一为「以 / 开头、以 / 结尾」。
 */
function normalizeBasePath(value) {
  var v = String(value === undefined || value === null ? "" : value).trim();
  if (!v || v === "/") return "";
  return "/" + v.replace(/^\/+/, "").replace(/\/+$/, "") + "/";
}

/** 读取构建期注入的部署前缀；浏览器端若未注入则回退为空串（根路径） */
function basePathFromEnv() {
  try {
    // 注意：这里保持字面量写法，构建期由 webpack.DefinePlugin 替换为字符串
    if (process.env.VUE_APP_BASE_PATH)
      return normalizeBasePath(process.env.VUE_APP_BASE_PATH);
  } catch (e) {
    /* 浏览器端未注入 process 时忽略 */
  }
  return "";
}

/** 站点访问前缀（含前后斜杠，根路径部署为空串），用于路由 base / 资源路径 / canonical */
var BASE_PATH = basePathFromEnv();

/** 业务主题关键词（数据品类 + 风险 / 信用维度），数据产品、接口列表、技术服务等页面复用 */
var BUSINESS_KEYWORDS =
  // 数据品类与服务能力
  "商业数据,数据监控,数据服务,数据交易,公开数据抓取,API," +
  // 数据维度
  "工商数据,司法数据,税务数据,经营数据,知识产权数据," +
  // 风险 / 信用 / 关联维度
  "经营风险,司法风险,企业信用,企业资质,税务评级,信用等级,失信人,被执行人,抵押质押,企业黑名单,关联关系,实际控制人," +
  // 数据接口与报告
  "工商数据接口,司法数据接口,裁判文书接口,税务数据接口,知识产权数据接口,招投标数据接口,股权穿透接口,企业信用报告";

module.exports = {
  /** 站点根地址（无结尾斜杠），用于 canonical / og:url / sitemap */
  url: SITE_URL,
  /** 站点访问前缀（如 '/xxx/'；根路径部署为 ''） */
  basePath: BASE_PATH,
  /** 前缀归一化工具（Node 侧构建脚本与 webpack 配置共用） */
  normalizeBasePath: normalizeBasePath,
  /** 品牌名（导航、页脚、结构化数据展示名） */
  name: "动态时序科技",
  /** 公司全称（结构化数据 legalName / 版权声明） */
  legalName: "动态时序科技有限公司",
  /** 首页标题，索引页兜底标题同样使用该值 */
  defaultTitle: "动态时序科技｜商业数据监控及 API 调用服务",
  /** 站点默认描述 */
  description:
    "动态时序科技提供商业数据监控与 API 调用服务：200+ 标准/可定制化接口，覆盖工商、司法风险、经营风险、知识产权、关联关系等 17 大数据分类，支持在线测试、按次调用与企业定制。",
  /** 站点默认关键词 */
  keywords:
    "动态时序,动态时序科技," +
    BUSINESS_KEYWORDS +
    ",API 接口,企业信息查询,数据治理,主数据管理",
  /** 业务主题关键词（数据品类 + 风险 / 信用维度），供数据产品、接口列表、技术服务等页面复用 */
  businessKeywords: BUSINESS_KEYWORDS,
  /** 社交分享图（1200×630，放在 static/ 下因此不带 hash，可长期缓存） */
  ogImage: "/static/img/og-cover.jpg",
  /** 品牌 logo（结构化数据 organization.logo 使用，建议 ≥112×112 的方形/横版图） */
  logo: "/static/img/logo.png",
  /** 主题色（浏览器地址栏 / PWA 场景） */
  themeColor: "#1d4ed8",
  /** 默认语言 */
  locale: "zh_CN",
  /** 联系方式与地址（结构化数据与联系我们页共用） */
  email: "service@workatdata.com",
  address: {
    street: "北三环西路32号 恒润国际大厦",
    locality: "北京市",
    region: "北京市",
    country: "CN",
  },
  /** 备案信息 */
  icp: "京ICP备2022012793号-1",
  /** 站内搜索入口（用于 WebSite 结构化数据的 SearchAction） */
  searchPath: "/allApi?name={search_term_string}",
};



// WEBPACK FOOTER //
// ./src/seo/site.js